import * as s from "@gromia/components/theme/t.module.css";
import {
  FaqPreview,
  FaqPreviewItem,
} from "@gromia/components/ui/FaqPreviewToggle";
import { Text } from "@gromia/components/ui/Text";
import strings from "@gromia/strings/landingSell";
import { useString } from "@gromia/utils/useString";
import cx from "classnames";
import * as React from "react";

export function Faq() {
  const { tx } = useString("landingSell", strings);
  return (
    <section
      className={cx(s.bgLight2, s.space2, s.positionRelative, s.textCenter)}
    >
      <div className={cx(s.container)}>
        <Text tag="p" s="pill">
          {tx("faqPill")}
        </Text>
        <Text tag="h2" s="title">
          {tx("faqTitle")}
        </Text>
        <Text tag="p" s="p">
          {tx("faqText")}
        </Text>
        <div className={cx(s.spaceTop2, s.maxWidth680, s.mxAuto)}>
          <FaqPreview>
            <FaqPreviewItem title={tx("faq1Title")}>
              {tx("faq1Text")}
            </FaqPreviewItem>
            <FaqPreviewItem title={tx("faq2Title")}>
              {tx("faq2Text")}
            </FaqPreviewItem>
            <FaqPreviewItem title={tx("faq3Title")}>
              {tx("faq3Text")}
            </FaqPreviewItem>
            <FaqPreviewItem title={tx("faq4Title")}>
              {tx("faq4Text")}
            </FaqPreviewItem>
          </FaqPreview>
        </div>
      </div>
    </section>
  );
}
